import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { offerApi } from '../services/api';
import { format } from 'date-fns';

const s = {
  title: { fontSize: 24, fontWeight: 700, color: '#1a1a2e', marginBottom: 24 },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#666', background: '#f9fafb', borderBottom: '1px solid #eee' },
  td: { padding: '12px 16px', fontSize: 13, borderBottom: '1px solid #f0f0f0', color: '#333' },
  badge: { display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, background: '#e0e7ff', color: '#3730a3' },
  pager: { display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' },
  pageBtn: { padding: '6px 14px', border: '1px solid #ddd', borderRadius: 4, background: '#fff', cursor: 'pointer', fontSize: 13 },
};

export default function AuditPage() {
  const [page, setPage] = useState(0);
  const { data, isLoading } = useQuery({
    queryKey: ['audit', page],
    queryFn: () => offerApi.auditLogs(page).then(r => r.data),
  });

  return (
    <div>
      <h1 style={s.title}>Audit Logs</h1>
      <table style={s.table}>
        <thead>
          <tr>
            <th style={s.th}>Action</th>
            <th style={s.th}>Offer ID</th>
            <th style={s.th}>IP Address</th>
            <th style={s.th}>Device</th>
            <th style={s.th}>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr><td style={{ ...s.td, textAlign: 'center' }} colSpan={5}>Loading...</td></tr>
          )}
          {data?.content?.map(log => (
            <tr key={log.id}>
              <td style={s.td}><span style={s.badge}>{log.action}</span></td>
              <td style={s.td} title={log.offerId}>{log.offerId?.substring(0, 8)}...</td>
              <td style={s.td}>{log.ip}</td>
              <td style={s.td} title={log.device}>{log.device?.substring(0, 40)}...</td>
              <td style={s.td}>{format(new Date(log.createdAt), 'MMM d, yyyy HH:mm:ss')}</td>
            </tr>
          ))}
          {!isLoading && !data?.content?.length && (
            <tr><td style={{ ...s.td, textAlign: 'center', color: '#999' }} colSpan={5}>No audit logs</td></tr>
          )}
        </tbody>
      </table>
      {data && (
        <div style={s.pager}>
          <button style={s.pageBtn} disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
          <span style={{ padding: '6px 12px', fontSize: 13 }}>Page {page + 1} of {data.totalPages}</span>
          <button style={s.pageBtn} disabled={page >= data.totalPages - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
        </div>
      )}
    </div>
  );
}
